import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

// Packages
import { Elements } from 'react-stripe-elements'

// API
import * as API  from '../../../utils/api'

// Actions
import {
  showModal,
} from '../../../actions/modal'

// Components
import CreditCardForm from '../../../components/Forms/CreditCardForm'
import FlashMessage from '../../../components/Global/FlashMessage'
import PaymentNote from '../../../components/Payment/PaymentNote'

class SignupPayment extends Component {

  state = {
    status: '',
    errorMessage: '',
    numberOfSports: '',
    athleteUsername: '',
    taxRate: '0.0',
    oneTimeFee: 0,
    activationFee: 5,
  }

  componentDidMount() {
    // Leaving this function here for the time being as the client's
    // pricing model may change soon, necessitating a call to our API
    // for a one time fee:
    //
    // API.getOneTimeFee().then(response => {
    //   if (response.errors || response.error) {
    //     console.log('Error getting One Time Fee')
    //   } else {
    //     this.setState({
    //       oneTimeFee: parseFloat(response.price_in_dollars)
    //     })
    //   }
    // })

    const {
      maintained_profile,
      participations
    } = this.props.onboarding

    this.setState({
      numberOfSports: participations.length,
      athleteUsername: maintained_profile.username
    })
  }

  componentWillReceiveProps(nextProps) {
    const { username } = this.props.onboarding.maintained_profile

    if (nextProps.onboarding.stripePaymentSuccessful) {
      this.props.handleFormSubmit(`/${username}`)
    }
  }

  handleGetTaxRate = (zipCode) =>  {
    const { user } = this.props

    API.getTaxRate(user, zipCode).then(response => {
      if (response.errors || response.error) {
        this.setState({
          errorMessage: response.errors[0] ? response.errors[0] : 'Error getting tax rate. Please try again.'
        })
      } else {
        this.setState({
          taxRate: response.totalRate
        })
      }
    })
  }

  handleInitialSubmit = (stripeResponse, address) => {
    if (stripeResponse.error) {
      window.scrollTo(0, 0)
      this.setState({
        errorMessage: stripeResponse.error.message
      })
    } else {
      this.showConfirmationModal(stripeResponse.token.id, address)
    }
  }

  showConfirmationModal(token, address) {
    const { coupon } = this.props.onboarding
    const {
      athleteUsername,
      numberOfSports,
      taxRate,
    } = this.state

    let modal = {
      modalType: 'stripe-payment-confirmation',
      optionalProps: {
        token: token,
        taxRate: taxRate,
        address: address,
        coupon: coupon,
        athleteUsername: athleteUsername,
        numberOfSports: numberOfSports,
        modalLocation: 'onboarding'
      }
    }

    this.props.showModal(modal)
  }

  renderFormStep() {
    const { role } = this.props.user

    return role === 'parent'
    ? ( <p> Step 5 of 5 </p> )
    : ( <p> Step 4 of 4 </p> )
  }

  renderStripeErrorMessage() {
    const { errorMessage } = this.state
    return errorMessage.length > 0
    ? (
      <FlashMessage optionalClasses='error'>
        {errorMessage}
      </FlashMessage>
    )
    : ''
  }

  getPaymentNote = () => {
    const { coupon } = this.props.onboarding
    const { numberOfSports, taxRate, oneTimeFee, activationFee } = this.state

    return (
      <PaymentNote
        coupon={coupon}
        numberOfSports={numberOfSports}
        taxRate={taxRate}
        oneTimeFee={oneTimeFee}
        activationFee={activationFee}
      />
    )
  }

  render() {
    const { appName } = this.props
    const { coupon } = this.props.onboarding
    const { status } = this.state

    return (
      <div className='onboarding-sign-up-payment'>
        <Helmet>
          <title>{appName} | Payment</title>
        </Helmet>
        <header>
          <h2>Premier Profile</h2>
        </header>
        {this.renderStripeErrorMessage()}
        <Elements>
          <CreditCardForm
            submitText='Submit Payment'
            handleFormSubmit={this.handleInitialSubmit}
            getTaxRate={this.handleGetTaxRate}
            validateCoupon={this.validateCoupon}
            coupon={coupon}
            hideCouponField
            status={status}
            paymentNote={this.getPaymentNote()}
          />
        </Elements>
        <div className="back-link-container">
          <p className="note">
            Note: Payment is final.  After submitting payment, you cannot change or add sports.
          </p>
          <a
            to="/sign-up/sport-selection"
            onClick={() => this.props.handleFormChange('sport-selection', 'sign-up-payment')}
            className="text-link"
          >
            Reset Selected Sports
          </a>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (modalType) => {
      dispatch(showModal(modalType))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPayment)

// Keeping this note in case client changes pricing model again:

// taxMessage() {
//   if (this.state.taxRate !== '0.0') {
//     return "(including tax)"
//   } else {
//     return "(plus tax)"
//   }
// }


// chargeLineItem = (chargeAmount, oneTimeFee = false) => {
//   return this.calculateRateWithTax(this.calculateWithDiscount(chargeAmount, oneTimeFee)).toFixed(2)
// }
// <hr/>
// <div className="payment-note-secondary">
//   <p>
//     * Payment will appear as two charges on your card's statement:
//   </p>
//   <ul>
//     <li>
//       ${this.chargeLineItem(oneTimeFee, true)} - one-time registration fee <span className="sub-text">{this.taxMessage()}</span>
//     </li>
//     <li>
//       ${this.chargeLineItem(this.getAnnualFee())} - annual payment, {numberOfSports} sport{numberOfSports > 1 ? 's' : ''} @ $99/sport <span className="sub-text">{this.taxMessage()}</span>
//     </li>
//   </ul>
// </div>



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/SignupPayment.js